<template>
    <div style="width: 1000px;min-height:100vh;display: flex;justify-content: center;align-items: center;margin: 0 auto;">
        <div style="margin-top: 120px;">
            <div style="width: 1000px;height:700px;background: #FFFFFF">
                <div style="clear: both;display: flex;align-items: center;padding-top: 40px;">
                    <div style="font-size: 25px;color:#444444;font-weight:bold;display: flex;justify-content: center;flex: 1;">投标登记表</div>
                </div>
                <div style="clear: both;padding-top: 30px;">
                    <div style="width: 920px;height: 10px;background: #FF9800;border-radius: 20px 20px 0px 0px;margin: 0 auto;"></div>
                    <div class="gradient-border" style="width: 916px;min-height: 450px;clear: both;margin: 0 auto;box-shadow: 0px 2px 6px 1px rgba(0,0,0,0.16);">
                        <teble style="width: 100%;font-size: 14px;">
                            <tr class="typeface">
                                <th style=" width: 100px;height: 20px;padding: 23px 42.5px;font-size: 17px; color: #444444;border-left:1px solid #808080;border-right:1px solid #CFCFCF;font-weight: bold;border-bottom:1px solid #CFCFCF;border-left: none">项目名称</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">{{content.fd_1677729356192}}</td>
                                <th style=" width: 100px;height: 20px;padding: 23px 41px;font-size: 17px; color: #444444;font-weight: bold;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">项目所在地</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #808080;border-right: none">{{content.fd_1704278443719}}</td>
                            </tr>
                        </teble>
                        <teble style="width: 100%;font-size: 14px;">
                            <tr class="typeface">
                                <th style=" width: 100px;height: 20px;padding: 23px 42.5px;font-size: 17px; color: #444444;border-left:1px solid #808080;border-right:1px solid #CFCFCF;font-weight: bold;border-bottom:1px solid #CFCFCF;border-left: none">项目类型</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">{{content.fd_1704278445689}}</td>
                                <th style=" width: 100px;height: 20px;padding: 23px 41px;font-size: 17px; color: #444444;font-weight: bold;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">标递</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #808080;border-right: none">{{content.fd_1704278448714}}</td>
                            </tr>
                        </teble>
                        <table border="1" style="width: 100%;height: 50px;overflow: hidden;font-size: 14px;border: none;">
                            <tr class="typeface">
                                <th class="title">开标日期</th>
                                <td class="content">{{content.fd_1704278458105}}</td>
                            </tr>
                        </table>
                        <teble style="width: 100%;font-size: 14px;">
                            <tr class="typeface">
                                <th style=" width: 100px;height: 20px;padding: 23px 42.5px;font-size: 17px; color: #444444;border-left:1px solid #808080;border-right:1px solid #CFCFCF;font-weight: bold;border-bottom:1px solid #CFCFCF;border-left: none">招标单位</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">{{content.fd_1704278472007}}</td>
                                <th style=" width: 100px;height: 20px;padding: 23px 41px;font-size: 17px; color: #444444;font-weight: bold;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">代理公司</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #808080;border-right: none">{{content.fd_1704278473915}}</td>
                            </tr>
                        </teble>
                        <teble style="width: 100%;font-size: 14px;">
                            <tr class="typeface">
                                <th style=" width: 142px;height: 20px;padding: 23px 22px;font-size: 17px; color: #444444;border-left:1px solid #808080;border-right:1px solid #CFCFCF;font-weight: bold;border-bottom:1px solid #CFCFCF;border-left: none">投标保证金(元)</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">{{content.fd_1704278480607}}</td>
                                <th style=" width: 162px;height: 20px;padding: 23px 10px;font-size: 17px; color: #444444;font-weight: bold;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">投标保证金退还日期</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #808080;border-right: none">{{content.fd_1704278482905}}</td>
                            </tr>
                            <tr class="typeface">
                                <th style=" width: 142px;height: 20px;padding: 23px 22px;font-size: 17px; color: #444444;border-left:1px solid #808080;border-right:1px solid #CFCFCF;font-weight: bold;border-bottom:1px solid #CFCFCF;border-left: none">代理公司联系人</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">{{content.fd_1704278497138}}</td>
                                <th style=" width: 100px;height: 20px;padding: 23px 41px;font-size: 17px; color: #444444;font-weight: bold;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">联系电话</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #808080;border-right: none">{{content.fd_1704278500223}}</td>
                            </tr>
                        </teble>
                        <table border="1" style="width: 100%;height: 50px;overflow: hidden;font-size: 14px;border: none;">
                            <tr class="typeface">
                                <th class="title" style="border-bottom: none">备注</th>
                                <td class="content" style="border-bottom: none">{{content.fd_1704278512622}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {

    },

    computed: {

    },
    data () {
        return {
            content:{},
        }
    },
    mounted:function(){
        document.documentElement.scrollTop = document.body.scrollTop = 0;
        this.getRoomContent()
    },
    methods:{
        // 获取内容
        getRoomContent() {
            this.newApi.getRoomContentInfo({id: this.$route.params.id}).then(res =>{
                this.content = res.data.content;
                this.radiogo = res.data.content.fd_1702965880225
                this.radiocircle = res.data.content.fd_1702966153115
            })
        },

    }
}
</script>

<style scoped>
.title {
    width: 100px;
    height: 20px;
    padding: 23px 26px;
    font-size: 17px;
    color: #444444;
    border-bottom:1px solid #CFCFCF;
    font-weight: bold;
    border-right:1px solid #CFCFCF;
    border-left: none;
    border-top: none;
    font-family:'SimHei';

}
.content {
    font-size: 17px;
    height: 20px;
    color: #444444;
    width: 80%;
    border-bottom:1px solid #CFCFCF;
    border-top: none;
    border-left: none;
    border-right: none;
    padding: 10px;
}
.gradient-border {
    border-right: 2px solid #ddd;
    border-left: 2px solid #ddd;
    border-image: linear-gradient(rgb(255, 152, 0), #FFFFFF) 30 30;
}
</style>